import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
// import Header1 from '../components/Header1'
import Section from '../components/Ui/Section'
// import MainSubscripe from '../components/MainSubscripe'
import TravlForm from '../components/Contact/TravlForm'
import { useTranslation } from 'react-i18next'
import './Contact.css'
import ContactDetails from '../components/Contact/ContactDetails'
function Contact() {
  const { t } = useTranslation()
  return (
    <Box>
      <Box className='bgAbout'>
        <div className="overlay"></div>
        <Typography variant="h2" sx={{ zIndex: 2 }}>{t("contactMe.contactUs")}</Typography>
      </Box>
      <Section title={t("contactMe.contactUs")}>
        <Grid gap={1} rowGap={3} justifyContent={"space-betweena"} sx={{ display: 'flex', flexDirection: 'row', mt: 2, flexWrap: "wrap" }}>
          <Grid item sx={{ border: "1px solid #76232d", p: 1, borderRadius: 2, width: { md: "49%", xs: "100%" } }} xs={12} md={6} >
            <TravlForm />
          </Grid>
          <Grid item sx={{ border: "1px solid #76232d", p: 1, borderRadius: 2, width: { md: "49%", xs: "100%" }, display: 'flex', alignItems: 'flex-start' }} xs={12} md={6} >
            <ContactDetails />
          </Grid>
        </Grid>
      </Section>
      {/* <Section> */}
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3603.571993033549!2d51.40645836560671!3d25.419133717669194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDI1JzA5LjMiTiA1McKwMjQnMjQuMSJF!5e0!3m2!1sen!2seg!4v1692797687513!5m2!1sen!2seg"
        width="50%"
        height="450"
        title='prof'
        style={{ border: "2px solid #76232d", display: 'flex', margin: '30px auto', borderRadius: '30px', padding: '10px' }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"

      >

      </iframe>
      {/* </Section> */}
    </Box>
  )
}

export default Contact